import { Component, ElementRef, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PageBase, UIService } from 't4core';
import { ServiceGuyInfo } from "../../../../../projects/t4core/src/public-api";

@Component({
  styleUrls: ['./InventoryStatusDashboard.component.css'],
  selector: 'InventoryStatusDashboard',
  templateUrl: './InventoryStatusDashboard.component.html',
})

export class InventoryStatus extends PageBase implements OnInit
{
  public InventoryStatus: InventoryStatus[]


  constructor(el: ElementRef,
    private route: ActivatedRoute,
    private ui: UIService) {
    super(el, "InventoryStatusDashboard");
  }

  public async ngOnInit() {
    this.GetServiceGuys();
  }

  public async GetServiceGuys() {
    var token = this.UI.beginLoading("T4.Service.ServiceGuyDialog.ldrLoadingServiceGuy", "Loading serviceGuys", null);
    this.InventoryStatus = await this.Api.get<InventoryStatus[]>("Service/GetInventoryStatus");

    this.UI.loaderCompleted(token);
  }


  public async showServiceGuy(x) {

    var serviceGuy = await this.Api.get<ServiceGuyInfo>('Service/GetServiceGuy', { ServiceGuyId: x });
   
    var ret = await this.UI.openDialog('T4.Service.ServiceGuyDialog', { data: { guy: serviceGuy } });
    if (ret) {


      var token = this.UI.beginLoading("T4.Service.ServiceGuyDialog.ldrSavingServiceGuy", "Updating service guy", null);
      await this.Api.post<ServiceGuyInfo>('Service/UpdateServiceGuy', serviceGuy);

      this.UI.loaderCompleted(token);
    }
  }


}
